import { ImageIcon, Shirt, SquareUser, User } from 'lucide-react';

import { SelectedBackgroundCard } from '~/components/generator/cards/background-cards';
import { SelectedModelVariantCard } from '~/components/generator/cards/model-variant-cards';
import { SelectedPoseCard } from '~/components/generator/cards/pose-cards';
import { SelectedProductCard } from '~/components/generator/cards/product-cards';
import { GeneratorStep } from '~/schemas/generator/complete-generator-schema';

export const GENERATOR_STEP_CONFIGS = [
  {
    step: GeneratorStep.Product,
    fieldPath: 'productStep.products' as const,
    SelectedItemCardComponent: SelectedProductCard,
    selectedItemsIcon: Shirt,
    selectedItemsLabel: 'Selected Products'
  },
  {
    step: GeneratorStep.Model,
    fieldPath: 'modelStep.modelVariants' as const,
    SelectedItemCardComponent: SelectedModelVariantCard,
    selectedItemsIcon: SquareUser,
    selectedItemsLabel: 'Selected Model Variants'
  },
  {
    step: GeneratorStep.Pose,
    fieldPath: 'poseStep.poses' as const,
    SelectedItemCardComponent: SelectedPoseCard,
    selectedItemsIcon: User,
    selectedItemsLabel: 'Selected Poses'
  },
  {
    step: GeneratorStep.Background,
    fieldPath: 'backgroundStep.backgrounds' as const,
    SelectedItemCardComponent: SelectedBackgroundCard,
    selectedItemsIcon: ImageIcon,
    selectedItemsLabel: 'Selected Backgrounds'
  }
] as const;

type StepConfig = (typeof GENERATOR_STEP_CONFIGS)[number];

type StepConfigMap = {
  [K in StepConfig['step']]: Extract<StepConfig, { step: K }>;
};

export const GENERATOR_STEP_CONFIG_MAP = Object.fromEntries(
  GENERATOR_STEP_CONFIGS.map((config) => [config.step, config])
);
